<template>
  <v-layout align-center justify-center class="primary_dark" mx-0 row>
    <v-flex xs12 sm12 md12 my-6>
      <p class="white--text text-center my-0">Capitálica ®</p>
      <p class="white--text text-center my-0">2020</p>
      <p class="white--text text-center my-0">
        <a
          target="_blank"
          href="/AVISO_PRIVACIDAD.pdf"
          class="white--text text-center my-0"
          >Aviso de privacidad</a
        >
      </p>
    </v-flex>
  </v-layout>
</template>
<style scoped></style>
<script>
export default {
  data() {
    return {};
  }
};
</script>
